<script lang="ts">
	import { Text, SelectCard, Container, LinkWithIcon, CardGrid } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { openExternalLink } from 'src/helpers/utilities';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	const integrationsCards = [
		{
			id: 0,
			text: $format('text_support_ticket', {
				default: 'Support ticket',
			}),
			descriptiveText: $format('text_submit_request_assistance', {
				default: 'Submit a request for technical assistance.',
			}),
			actionText: $format('text_submit_ticket', {
				default: 'Submit a ticket',
			}),
			onClick: () => {
				openExternalLink('https://support.shelly.cloud/en/support/tickets/new');
			},
			icon: 'fat fa-ticket',
		},
		{
			id: 1,
			text: $format('text_faqs', {
				default: 'FAQs',
			}),
			descriptiveText: $format('text_browse_faq', {
				default: 'Browse our most frequently asked questions.',
			}),
			actionText: $format('text_open_faqs', {
				default: 'Open FAQs',
			}),
			onClick: () => {
				openExternalLink('https://support.shelly.cloud/en/support/solutions');
			},
			icon: 'fat fa-messages-question',
		},
		{
			id: 2,
			text: $format('text_feedback_forum', {
				default: 'Shelly community forum',
			}),
			descriptiveText: $format('text_feedback_forum_desc', {
				default: 'Get help from fellow users.',
			}),
			actionText: $format('text_open_community_forum', {
				default: 'Open community forum',
			}),
			onClick: () => openExternalLink('https://community.shelly.cloud/'),
			icon: 'fat fa-people-group',
		},
		{
			id: 5,
			text: $format('text_feedback_discord', {
				default: 'Shelly Discord community',
			}),
			descriptiveText: $format('text_feedback_discord_description', {
				default: 'Share feedback and follow updates with the Shelly team.',
			}),
			actionText: $format('text_open_discord', {
				default: 'Open Discord',
			}),
			onClick: () => openExternalLink('https://discord.gg/R3KzedX3MN'),
			icon: 'fa-brands fa-discord',
		},
		{
			id: 3,
			text: $format('text_facebook_group', {
				default: 'Shelly Facebook group',
			}),
			descriptiveText: $format('text_join_shelly_facebook', {
				default: 'Join the Shelly family on Facebook!',
			}),
			actionText: $format('text_join_facebook_group', {
				default: 'Join Facebook group',
			}),
			onClick: () => {
				openExternalLink('https://www.facebook.com/groups/ShellyIoTCommunitySupport/');
			},
			icon: 'fa-brands fa-facebook-f',
		},
		{
			id: 4,
			text: $format('text_shelly_shop', {
				default: 'Shelly shop',
			}),
			descriptiveText: $format('text_discover_shelly_products', {
				default: 'Discover and buy Shelly products.',
			}),
			actionText: $format('text_open_shelly_shop', {
				default: 'Open Shelly shop',
			}),
			onClick: () => {
				openExternalLink('https://www.shelly.com/collections/all-products');
			},
			icon: 'fak fa-solid-shelly',
		},
	];
</script>

<Container class="mb-s" noScroll>
	<Text class="mb-m text-bold" size="xl"
		>{$format('text_connect_and_explore', {
			default: 'Connect & Explore',
		})}
	</Text>

	<CardGrid sm={200} md={300} lg={300} noPaddingBottom>
		{#each integrationsCards as card}
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				class="width-auto"
				type="vertical"
				title={card.text}
				descriptiveText={card.descriptiveText}
				customActionMinHeight
				icon={card.icon}
			>
				<LinkWithIcon
					iconInLeft
					on:click={card.onClick}
					slot="customAction"
					size="m"
					icon="fal fa-external-link"
					href="/"
					text={card.actionText}
				/>
			</SelectCard>
		{/each}
	</CardGrid>
</Container>
